import { useEffect } from "react";

/**
 * Keeps a CSS variable on `scopeSelector` (closest ancestor of the ref) in sync with the
 * ref element's height, so elements below it can stick right underneath it.
 */
export const useStickyBlockHeight = (ref, scopeSelector, variableName) => {
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const scope = el.closest(scopeSelector);
    if (!scope) return undefined;
    const apply = () => {
      scope.style.setProperty(variableName, `${el.offsetHeight}px`);
    };
    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(el);
    window.addEventListener("resize", apply);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", apply);
    };
  }, [ref, scopeSelector, variableName]);
};
